import React from 'react';
import Layout from "./layout/Layout";
import SEO from "../common/SEO";
import SectionTitle from "../elements/sectionTitle/SectionTitle";
import ContactOne from "../elements/contact/ContactOne";

const ContactUs = () => {
    return (
        <>
            <SEO title="Contact Us"/>
            <Layout>
                <div className="main-content">
                    {/* Start Contact Area  */}
                    <div className="rwt-contact-area rn-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 mb--40">
                                    <SectionTitle
                                        textAlign="text-center"
                                        radiusRounded=""
                                        subtitle=""
                                        title="Talk to us"
                                        description="We are excited to collaborate with you. Contact us today to get
                                        started on your path to a successful business solution."
                                    />
                                </div>
                            </div>
                            <ContactOne/>
                        </div>
                    </div>
                    {/* End Contact Area  */}
                </div>
            </Layout>
        </>
    )
}
export default ContactUs;